import React, { useState } from "react";
import { TipoEntrega } from "../AbaTipoEntrega";
import clsx from "clsx";
import { classeParaLabelsFormularioComFundoEscuro } from "../../../../estilos/classeParaLabelsFormularioComFundoEscuro";
import globalMU from "../../../../../globalMU";
import store from "app/redux/store/store";
import { gravarTelasAlteradasNaoSalvaAction } from "app/redux/telaOrcamentoAlteradaNaoSalvaSlice";
const estiloEditarTipoEntrega =
  require("../../../../estilos/editarEntregaFreteCompartilhado.module.scss").default;
const estilosFormulario = require('../../../../estilos/formulario.module.scss').default

export type OpcaoEntrega = {
  "Description": string,
  "Value": string
}

export type EditarTipoEntregaProps = {
  somenteLeitura: boolean;
  tipoEntrega: TipoEntrega;
  opcoesEntrega: OpcaoEntrega[];
  onAplicarTipoEntrega: (tipoEntrega: TipoEntrega) => void;
  mostrarNomeComoCodigo: boolean
};

const EditarTipoEntrega = (props: EditarTipoEntregaProps) => {
  const [carga, setCarga] = useState(props.tipoEntrega.Carga);
  const [opcaoEntrega, setOpcaoEntrega] = useState(
    props.tipoEntrega.OpcaoEntrega
  );
  function objetoDeRetornoParaOBanco() {
    let aux: TipoEntrega = props.tipoEntrega;
    aux.Carga = carga;
    aux.OpcaoEntrega = opcaoEntrega;
    return aux;
  }
  return (
    <>
      <div className={clsx(estilosFormulario.formulario, classeParaLabelsFormularioComFundoEscuro)}>
        <label>{props.mostrarNomeComoCodigo ? "Código" : "Referência"}</label>
        <div style={{ fontWeight: 700, backgroundColor: "var(--mu-superficie, #FFFFFF)" }}>
          {props.tipoEntrega.Codigo.toUpperCase()}
        </div>

        <label>Descrição</label>
        <div style={{ fontWeight: 700, backgroundColor: "var(--mu-superficie, #FFFFFF)" }}>
          {props.tipoEntrega.Descricao.toUpperCase()}
        </div>

        <label>Quantidade</label>
        <div>{globalMU.formatarValorNumerico(props.tipoEntrega.Quantidade, 3, false)}</div>

        <label>Tipo Entrega</label>
        <div>{props.tipoEntrega.DescricaoTipoEntrega}</div>

        <label>Peso Total</label>
        <div>{globalMU.formatarValorNumerico(props.tipoEntrega.PesoTotal, 3, false)}</div>

        <label>Opção Entrega</label>
        <div>
          <select
            disabled={props.somenteLeitura}
            name="Opcao Entrega"
            value={(opcaoEntrega) ?? ""}
            autoFocus
            id="EditarTipoEntrega_OpcaoDeEntrega"
            onChange={(e) => {
              setOpcaoEntrega(e.target.value);
              store.dispatch(gravarTelasAlteradasNaoSalvaAction("telaEntrega_tipoEntrega"))
            }}
          >
            {props.opcoesEntrega.map((opcao) => (
              <option key={opcao.Value} value={opcao.Value}>
                {opcao.Description}
              </option>
            ))}
          </select>
        </div>

        <label>Carga</label>
        <div>
          <input
            disabled={props.somenteLeitura}
            name="Carga"
            type="text"
            id="EditarTipoEntrega_Carga"
            value={(carga) ?? ""}
            onChange={(e) => {setCarga(e.target.value), store.dispatch(gravarTelasAlteradasNaoSalvaAction("telaEntrega_tipoEntrega"))}}
            maxLength={1}
          />
        </div>
      </div>
      {!props.somenteLeitura &&
          (
            <div>
              <button
                className={estiloEditarTipoEntrega.botao}
                onClick = {() => props.onAplicarTipoEntrega( objetoDeRetornoParaOBanco())}>
                  Aplicar
              </button>
            </div>
          )}
          {<section style={{ marginBottom: "30px" }} />}
    </>
  );
};

export { EditarTipoEntrega };
